import { Box, Card, Chip, IconButton } from "@mui/material";
import PageTitleSubtitle from "../../../components/PageTitleSubTitle";
import localize from "../../../common/localize";
import { Delete } from "@mui/icons-material";

export default function SupplyItem({ item, onDelete }) {
  return (
    <Card
      className="w-full flex flex-col gap-2 p-2"
      variant="outlined"
      sx={{ borderRadius: "5px" }}
    >
      <Box className="w-full flex gap-2 justify-between items-center">
        <Box className="flex gap-2 items-center">
          {onDelete && (
            <IconButton onClick={onDelete}>
              <Delete className="error_icon_color" />
            </IconButton>
          )}
          <PageTitleSubtitle
            useEventTitleStyle
            useFieldTitleStyle
            title={item.Name ?? item.SupplyElement?.Name}
            subtitle={`${localize.code}: ${
              item.Code ?? item.SupplyElement?.Code
            }`}
          />
        </Box>

        <Box sx={{ width: "60px" }}>
          <Chip
            sx={{
              "& .MuiChip-deleteIcon": {
                color: "white",
              },
              "& .MuiChip-deleteIcon:hover": {
                color: "white",
              },
            }}
            style={{
              margin: "2px",
              fontSize: "12px",
              fontWeight: 400,
              backgroundColor: "#10366E",
              color: "white",
              width: "100%",
            }}
            label={item.Quantity ?? 1}
          />
        </Box>
      </Box>
    </Card>
  );
}
